import { metricCardContainer as containerClasses } from '../metric-card-styles';

/**
 * Asset-mix count color by number of missing classes: complete (0 missing) = green,
 * 1-3 missing = orange, 4+ missing = red. Disabled drops to the shared disabled gray.
 */
function getAssetMixColor(missing: number, isDisabled: boolean): string {
  if (isDisabled) return 'text-fg-disabled-subtle';
  if (missing === 0) return 'text-fg-success-secondary';
  if (missing >= 4) return 'text-error-primary';
  return 'text-orange-500';
}

export { containerClasses, getAssetMixColor };
